<template>
    <div id="vue-app" class="max-w-7xl -mx-g md:mx-auto">
        <div
            v-if="$store.state.err"
            v-text="$store.state.err"
            class="bg-white shadow sm:rounded-lg text-red-700 bg-red-100 p-4 my-4 text-center"
        ></div>
        <div v-if="$store.state.configs.routing">
            <transition name="fade" mode="out-in">
                <!-- <Layout v-if="!['tours'].includes($route.name)"> -->
                <Layout v-if="$store.state.step == null || ($store.state.step != null && $store.state.step != Object.keys($store.state.steps).length)">
                    <router-view :key="$route.path"></router-view>
                </Layout>

                <router-view v-else :key="$route.path"></router-view>
            </transition>
        </div>
        <div v-else>
            <transition name="fade" mode="out-in">
                <Layout v-if="$store.state.step == null || ($store.state.step != null && $store.state.step != Object.keys($store.state.steps).length)">
                    <Step></Step>
                </Layout>
            </transition>
        </div>
    </div>
</template>

<script>
import Layout from "./components/BookingLayout";
import Step from "./components/Step";

export default {
    name: "App",
    components: {
        Layout,
        Step
    },
    data() {
        return {
            use_routing: false
        };
    },
    created() {

        let props = document.getElementById('vue-app').dataset.props;

        if(typeof props != "undefined") {
            this.$store.commit('updateField', {
                field: 'configs',
                value: JSON.parse(props)
            });
        }
    }
};
</script>

<style lang="scss">
</style>
